import { Callback, PageNavAction } from "@/types/types";
import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import Template from "./Retail.template.vue";

@Component({
  mixins: [Template]
})
export default class RetailComponent extends Vue {
  @Action("changeTitle", { namespace: "MegaMenuModule" })
  public changeTitleAction!: Callback;
  @Action("changeSubTitle", { namespace: "MegaMenuModule" })
  public changeSubTitleAction!: Callback;
  @Action("changeIcon", { namespace: "MegaMenuModule" })
  public changeIconAction!: Callback;
  @Action("setPageNav", { namespace: "PageNavModule" })
  public setPageNav!: PageNavAction;

  constructor() {
    super();
    this.changeTitleAction("retail");
    this.changeSubTitleAction("");
    this.changeIconAction(
      require("@/assets/images/icon_primary_menu_retail@2x.png")
    );
  }

  public created() {
    this.setPageNav(null);
  }
}
